<template>
  <div :class="{'p-6': $mq != 'mobile', 'p-4 w-full': $mq == 'mobile'}">
    <div :class="{'p-6 border': $mq != 'mobile'}">
      <div class="my-6 relative">
        <p
          class="uppercase text-lg font-light text-center my-6"
          v-if="$mq != 'mobile'"
        >To get started enter your vault &amp; business details below</p>
        <div
          class="text-center sm:text-right sm:absolute sm:right-0 sm:top-0 text-sm font-light text-grey"
        >
          <span class="text-brand">*</span> Required fields
        </div>
      </div>

      <form class="py-4 mt-4 text-center sm:text-left" @submit.prevent="validateAndNext">
        <div class="flex flex-wrap">
          <div class="w-full sm:w-1/2 sm:pr-8 flex flex-col">
            <div class="flex-1">
              <label class="font-medium">
                <span class="text-brand">*</span> BusinessVault name
              </label>
              <input
                type="text"
                class="w-full border border-grey-light py-2 px-3 pt-3 mt-2 rounded"
                v-model="form.vault.name"
                v-validate="'required'"
                name="vault_name"
                tabindex="1"
                :class="{'border-red':errors.has('vault_name')}"
                placeholder="Enter your BusinessVault's Name"
              >
              <div
                v-show="errors.has('vault_name')"
                class="text-red text-sm mt-2"
              >{{ errors.first('vault_name') }}</div>
            </div>
            <div class="flex-1">
              <p class="my-2 text-grey text-xs">This is usually your company name.</p>
              <p class="my-2 text-grey text-xs">Your Vault name can be amended at a later date.</p>
            </div>
          </div>

          <div class="w-full sm:pr-8" :class="{'sm:w-1/4': show_others, 'sm:w-1/2': !show_others}">
            <label class="font-medium"><span class="text-brand">*</span> Primary business activity</label>
            <multiselect
              v-model="form.vault.building_type"
              :class="{'invalid': errors.has('activity')}"
              class="mt-2 border border-grey-lighter rounded"
              name="activity"
              v-validate="'required'"
              placeholder="Select an Activity"
              :options="activities"
              :searchable="false"
              :showLabels="false"
              :tabindex="2"
            ></multiselect>
            <div
              v-show="errors.has('activity')"
              class="text-red text-sm mt-2"
            >{{ errors.first('activity') }}</div>
          </div>

          <div class="w-full sm:w-1/4" v-if="show_others">
            <label class="font-light text-sm"><span class="text-brand">*</span> Specify if Others:</label>
            <input
              type="text"
              class="w-full border border-grey-light py-2 px-3 pt-3 mt-2 rounded"
              v-model="specify_others"
              v-validate="'required'"
              name="specify"
              tabindex="1"
              :class="{'border-red':errors.has('specify')}"
              placeholder="Others"
            >
            <div
              v-show="errors.has('specify')"
              class="text-red text-sm mt-2"
            >{{ errors.first('specify') }}</div>
          </div>
        </div>
        <button type="submit" class="invisible"></button>
      </form>
    </div>
    <div class="text-center mt-4" v-if="detailReview">
      <button
        class="border bg-grey-lighter p-4 w-32 text-black border-grey rounded font-medium"
        type="submit"
        @click="backToFinish()"
      >Back</button>
    </div>

    <div class="flex flex-row justify-end mt-4" v-else>
      <button
        class="border bg-brand p-4 w-32 text-white rounded font-medium"
        type="submit"
        @click="validateAndNext()"
      >Continue</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value", "step", "detail-review", "steps"],

  data() {
    return {
      form: _.cloneDeep(this.value),
      next: "",

      specify_others: "",

      activities: [
        "Agriculture, Forestry, and Fishing",
        "Mining",
        "Manufacturing",
        "Electricity, Gas, Water, and Waste Services",
        "Construction",
        "Wholesale Trade",
        "Retail Trade",
        "Accommodation and Food Services",
        "Transport, Postal and Warehousing",
        "Information Media and Telecommunications",
        "Financial and Insurance Services",
        "Rental, Hiring Real Estate and Strata Management",
        "Professional, Scientific and Technical Services",
        "Administrative and Support Services",
        "Public Administration and Safety",
        "Education and Training",
        "Health Care and Social Assistance",
        "Arts and Recreation Services",
        "Other Services"
      ],

      show_others: false
    };
  },

  mounted() {
    let next = _.toNumber(this.step) + 1;
    this.next = next;

    if (!_.isEmpty(this.form.vault.strata_plan_number)) {
      // reassignment of values again
      this.show_others = true;
      this.specify_others = this.form.vault.building_type;
      this.form.vault.building_type = this.form.vault.strata_plan_number;
      this.form.vault.strata_plan_number = "";
    }
  },

  methods: {
    validateAndNext() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (!_.isEmpty(this.specify_others)) {
            this.form.vault.building_type = this.specify_others;
            this.form.vault.strata_plan_number = "Other Services";
          }
          if (this.form.user != undefined) {
            this.form.user.company_name = this.form.vault.name;
          }
          this.$emit("go-to", {
            next_step: this.next
          });
        }
      });
    },

    checkValue() {
      const value = this.form.vault.building_type;
      this.show_others = false;
      if (value == "Other Services") {
        this.show_others = true;
      }
    },

    backToFinish() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit("go-to", {
            next_step: _.findLastKey(this.steps)
          });
        }
      });
    }
  },

  watch: {
    form: {
      deep: true,
      handler: function() {
        this.checkValue()
        this.$emit("input", this.form);
      }
    }
  }
};
</script>

<style>
</style>
